import createStory from '../createStory';

const title = "Meet Cierra, Our Founder"
const shortName="founderStory"
const preview=""

const element1 = <p className="storyBodyText"> coming soon! </p>

const story =  [element1]
// const story = [element1, element2, element3, element4, element5, element6, element7, element8, element9]
const founderStory = createStory (shortName, title, preview, story)

export default founderStory;